import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PasswordRules } from '@core/models';
import { MixedObject } from '@core/interfaces/mixed-object';

const EMAIL_REGEXP =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function isEmptyInputValue(value: any): boolean {
  return value == null || value.length === 0;
}

function hasValidLength(value: any): boolean {
  return value != null && typeof value.length === 'number';
}

export class FormValidators {
  static password(rules: PasswordRules): ValidatorFn | null {
    return (control: AbstractControl): MixedObject | null => {
      if (!rules || isEmptyInputValue(control.value) || !hasValidLength(control.value)) {
        return null;
      }

      if (rules.requiredLength) {
        const requiredLengthValid = control.value.length < rules.requiredLength
          ? {'requiredLength': {'requiredLength': rules.requiredLength, 'actualLength': control.value.length}}
          : null;

        if (requiredLengthValid !== null) {
          return requiredLengthValid;
        }
      }

      if (rules.requireLowercase) {
        const regExp = /[a-z]/g;
        const requireLowercaseValid = regExp.test(control.value) ? null : {'requireLowercase': true};

        if (requireLowercaseValid !== null) {
          return requireLowercaseValid;
        }
      }

      if (rules.requireUppercase) {
        const regExp = /[A-Z]/g;
        const requireUpperCaseValid = regExp.test(control.value) ? null : {'requireUppercase': true};

        if (requireUpperCaseValid !== null) {
          return requireUpperCaseValid;
        }
      }

      if (rules.requireNonAlphanumeric) {
        const regExp = /\W/g;
        const requireNonAlphanumericValid = regExp.test(control.value) ? null : {'requireNonAlphanumeric': true};

        if (requireNonAlphanumericValid !== null) {
          return requireNonAlphanumericValid;
        }
      }

      if (rules.requireDigit) {
        const regExp = /\d/g;
        const requireDigitValid = regExp.test(control.value) ? null : {'requireDigit': true};

        if (requireDigitValid !== null) {
          return requireDigitValid;
        }
      }
    };
  }

  static email(control: AbstractControl): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null;  // don't validate empty values to allow optional controls
    }
    return EMAIL_REGEXP.test(control.value) ? null : {'email': true};
  }
}
